import axios from "axios";

const httpClient = axios.create({
  baseURL: "/api/v1",
});

export const setHttpClientToken = (apiKey) => {
  httpClient.defaults.headers.common["x-api-key"] = apiKey;
};

export default httpClient;
